var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg040Exit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99994 18C7.99994 17.4477 8.44765 17 8.99994 17C9.55222 17 9.99994 17.4477 9.99994 18V20H19.9999V4H9.99994V6C9.99994 6.55228 9.55222 7 8.99994 7C8.44765 7 7.99994 6.55228 7.99994 6V3C7.99994 2.44772 8.44765 2 8.99994 2H20.9999C21.5522 2 21.9999 2.44772 21.9999 3V21C21.9999 21.5523 21.5522 22 20.9999 22H8.99994C8.44765 22 7.99994 21.5523 7.99994 21V18ZM5.99994 16.0058C5.7333 16.0058 5.47771 15.8993 5.28994 15.71L2.28994 12.71C2.10063 12.5222 1.99414 12.2666 1.99414 12C1.99414 11.7334 2.10063 11.4778 2.28994 11.29L5.28994 8.29C5.68206 7.89788 6.31782 7.89788 6.70994 8.29C7.10206 8.68212 7.10206 9.31788 6.70994 9.71L5.40994 11H15.9999C16.5522 11 16.9999 11.4477 16.9999 12C16.9999 12.5523 16.5522 13 15.9999 13H5.40994L6.70994 14.29C6.89925 14.4778 7.00574 14.7334 7.00574 15C7.00574 15.2666 6.89925 15.5222 6.70994 15.71C6.52217 15.8993 6.26658 16.0058 5.99994 16.0058Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg040Exit);
export default __webpack_public_path__ + "static/media/040-exit.62d6ccec1eef0dd97b68ecb4d19c6c7a.svg";
export { ForwardRef as ReactComponent };